import { render, staticRenderFns } from "./BreadCrumbs.vue?vue&type=template&id=04abfffa&scoped=true"
import script from "./BreadCrumbs.vue?vue&type=script&lang=ts"
export * from "./BreadCrumbs.vue?vue&type=script&lang=ts"
import style0 from "./BreadCrumbs.vue?vue&type=style&index=0&id=04abfffa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04abfffa",
  null
  
)

export default component.exports